// eslint-disable-next-line
import util from 'util';

// eslint-disable-next-line
import * as actionTypes from '../actionTypes';

import * as coreActions from '../core/actions';

import * as PhoneApi from './api';

import * as PortalApi from '../PortalApi';

import * as Twilio from './Twilio2';

/*
 * This is called in Twilio.js to refresh
 * the client token
 */
export const getToken = (completed) => {
  return function(dispatch, getState) {
    PhoneApi.getPhoneToken((token) => {
      if (typeof(completed) === 'function') {
        completed(token);
      }
    });
  }
}


/*
 * An active call has changed status.  Add any additional actions 
 * on call status change
 */
export const callStatusChange = (status) => {
  return function(dispatch, getState) {
    dispatch(setCallState(status));
    if (status === 'closed') {
      dispatch(setPhoneOutcall({}));
    }
  }
}

/* Error message from Twilio. */
export const errorEvent = (message) => {
  return function(dispatch, getState) {
    dispatch(coreActions.postSnackMessage('error', 'Phone Error', message));
    dispatch(setPhoneOutcall({}));
    dispatch(setPhoneMuted(false));    
  }
}

/* Start an outcall */
export const outcall = (phoneNumberId, outcallNumber) => {
  return function(dispatch, getState) {
  	dispatch(setPhoneOutcall({ phoneNumberId, outcallNumber }));
  	    PhoneApi.getOutcallPin((outcall) => {
  	      dispatch(setPhoneOutcall(outcall));
  	      Twilio.outboundCall({
  	        params : {
  	          outcallPin : outcall.outcallPin
  	        }
  	      }, dispatch, getState);
  	    }, (error, status, content) => {
  	      PortalApi.defaultErrorHandler(error, status, content);
  	      dispatch(setPhoneOutcall({}));
  	    }, phoneNumberId, outcallNumber);
  	  }
  	}

export const recordIvr = (recordingId, disconnectCallBack) => {
  if(recordingId === 'PERSONAL'){
    return function(dispatch, getState) {
      Twilio.recordGreeting(getState().core.user.userId, dispatch, getState, disconnectCallBack);
    }
  } else {
    return function(dispatch, getState) {
      Twilio.IvrGreeting(getState().core.user.userId, dispatch, getState, recordingId, "recordingIvr", disconnectCallBack);
    }
  }
}

export const playIvr = (recordingId) => {
  return function(dispatch, getState) {
    Twilio.IvrGreeting(getState().core.user.userId, dispatch, getState, recordingId, "playPrompt");
  }
}

/* Hangup the current call */
export const hangup = () => {
  return function(dispatch, getState) {
    util.log('Hanging up');
    Twilio.hangup();
  }
}

/* Toggle the mute */
export const toggleMute = () => {
  return function(dispatch, getState) {
    Twilio.toggleMute();
  }
}

/* Send DTMF */
export const dtmf = (digit) => {
  return function(dispatch, getState) {
    Twilio.playDTMF(digit);
  }
}



/* */
export const setCallState = (callState) => ({
  type : actionTypes.SET_CALL_STATE,
  payload : { callState }
});


/* */
export const setPhoneOutcall = (phoneOutcall) => ({
  type : actionTypes.SET_PHONE_OUTCALL,
  payload : { phoneOutcall }
});

/* */
export const setPhoneMuted = (phoneMuted) => ({
  type : actionTypes.SET_PHONE_MUTED,
  payload : { phoneMuted }
});

/* */
export const setPhoneOpen = (phoneOpen) => ({
  type : actionTypes.SET_PHONE_OPEN,
  payload : { phoneOpen }
});

/* */
export const setOutdialNumber = (outdialNumber) => ({
  type : actionTypes.SET_OUTDIAL_NUMBER,
  payload : { outdialNumber }
});

